module.exports = {"title":"更改密碼 | GoGoVan 台灣","password_headline":"更改密碼","password_email":"電郵地址","password_password":"新密碼","password_confirm_password":"確認密碼","password_button_request_reset":"要求重設密碼","password_button_submit":"更改密碼","password_respond":"已更改密碼，請檢查電郵確認。","password_email_not_found":"你的電郵沒有被登記。請先<a href=\"#register\" class=\"global-text-blue dialog\">註冊</a>。","password_error_password_length":"您的密碼不足8位","password_error_password_equal":"對不起，兩次輸入的密碼並不相同。","password_error_token_expired":"此更改密碼連結已過時。"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/password/locale.json
// module id = 740
// module chunks = 0 1 2 3 4 5